<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->

                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="studentStatus">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div>
                                            <h3 class="main-content-label mb-1"><b>
                                                    Student Status
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Student Status
                                            </p>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width input">
                                                        <mat-label> List</mat-label>
                                                        <mat-select required formControlName="EcId" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'ListDesc'"
                                                                [array]="ListOfMarks"
                                                                (filteredReturn)=" filteredListOfCourse =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredListOfCourse"
                                                                [value]="item.CEcId"  (click)="fetchListForRgNo(item)">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="studentStatus.controls['EcId'].touched && studentStatus.controls['EcId'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-4"></div>
                                            <div class="col-sm-4">
                                                <button type="button" (click)="getTableData()"
                                                    class="btn size1 btn-primary btn-icon-text floatright mt-1">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="15vh" src="../../assets/img/list.gif"
                                                            style="margin-right: 7px;">
                                                        List
                                                    </span>
                                                </button>
                                            </div>
                                            <div *ngIf="showForm" class="row">
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline"
                                                            class="example-full-width input">
                                                            <mat-label> Rg No</mat-label>
                                                            <mat-select required formControlName="RgId" #select23
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'ListDesc'" [array]="ListOfRgNo"
                                                                    (filteredReturn)=" filteredListOfRgNo =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredListOfRgNo"
                                                                    [value]="item.RgId" (click)="getDetails(item)">
                                                                    {{item.RgNo}} - {{item.RgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="studentStatus.controls['RgId'].touched && studentStatus.controls['RgId'].errors?.required">
                                                            Mandatory
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-8">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Name </mat-label>
                                                            <input class="input" readonly matInput
                                                                formControlName="RgName" placeholder="">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>
                                                                Student Status
                                                            </mat-label>
                                                            <mat-select #select333 placeholder=""  [disabled]="true"
                                                                class="colorblack" formControlName="StatusRg">
                                                                <mat-select-filter *ngIf="select333.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                    [array]="studentStatusList"
                                                                    (filteredReturn)="filteredstudentStatusList =$event">
                                                                </mat-select-filter>
                                                                <mat-option
                                                                    *ngFor="let item of filteredstudentStatusList"
                                                                    [value]="item.CdCode">
                                                                    {{item.CdDesc}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">

                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Set/Remove</mat-label>
                                                            <mat-select required formControlName="SetRem" #select104
                                                                class="colorblack">
                                                                <!-- <mat-option>Select</mat-option> -->
                                                                <mat-option value="S">Set</mat-option>
                                                                <mat-option value="R">Remove</mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="studentStatus.controls['SetRem'].touched && studentStatus.controls['SetRem'].errors?.required">
                                                            Mandatory
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Upto Year </mat-label>
                                                            <input class="input" matInput formControlName="BarToYr"
                                                                placeholder="">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select #select232 placeholder="Session"
                                                                class="colorblack" formControlName="BarToSn">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo">
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

<!-- 
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>
                                                                Exam Status
                                                            </mat-label>
                                                            <mat-select #select333 placeholder="StatusRe"
                                                                class="colorblack" formControlName="StatusRe">
                                                                <mat-select-filter *ngIf="select333.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                    [array]="examStatusList"
                                                                    (filteredReturn)="filteredExamStatusList =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredExamStatusList"
                                                                    [value]="item.CdCode">
                                                                    {{item.CdDesc}}
                                                                </mat-option>
                                                            </mat-select>

                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Set/Remove</mat-label>
                                                            <mat-select formControlName="SetRem" #select104
                                                                class="colorblack">
                                                                <mat-option value="S">Set</mat-option>
                                                                <mat-option value="R">Remove</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>New Course</mat-label>
                                                            <mat-select #select3 class="colorblack"
                                                                formControlName="CoCode">
                                                                <mat-select-filter *ngIf="select3.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                    [array]="CourseList"
                                                                    (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                                                <mat-option onkeydown="return (event.keyCode!=13);"
                                                                    *ngFor="let item of filteredCourseList"
                                                                    [value]="item.CoCode" (click)="getExamData(item)">
                                                                    {{item.CoCode}}-{{item.CoName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Branch </mat-label>
                                                            <input class="input" matInput formControlName="StrId"
                                                                placeholder="">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline"
                                                            class="example-full-width">
                                                            <mat-label>
                                                                For Exam
                                                            </mat-label>
                                                            <mat-select #select52 class="colorblack"
                                                                formControlName="EmId">
                                                                <mat-select-filter *ngIf="select52.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                    [array]="examList"
                                                                    (filteredReturn)="filteredListExam =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredListExam"
                                                                    [value]="item.EmId">
                                                                    {{item.EmCode}} - {{item.EmName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div> -->

                                                <!-- <div class="col-sm-6"></div>
                                                <div class="col-sm-3 mt-3">
                                                    <div class="form-group">
                                                        <div class="row">
                                                            <div class="col-sm-6 mt-3">
                                                                <mat-label class="mt-3 lclass"><span
                                                                        class="required-asterisk mr-1"></span>Delete
                                                                    Record</mat-label>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <mat-radio-group formControlName="Chng"
                                                                    class="example-full-width">
                                                                    <div class="row">
                                                                        <div class="col-sm-4 p-1 mt-3">
                                                                            <mat-radio-button value='Y'>Deletes Past
                                                                                Record</mat-radio-button>
                                                                        </div>

                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-sm-3"></div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>For This & Later Exam </mat-label>
                                                            <input class="input" matInput formControlName="Name"
                                                                placeholder="">
                                                        </mat-form-field>
                                                    </div>
                                                </div> -->

                                                <div class="col-sm-12">
                                                                 <button type="button" (click)="reset()"
                                                                class="btn size1 btn-primary btn-icon-text ml-2 floatright mt-1">
                                                                <span style="display: contents; align-items: center;">
                                                                    <img width="15vh" src="../../assets/img/save.gif"
                                                                        style="margin-right: 7px;">
                                                                    Reset
                                                                </span>
                                                            </button>
                                                    <button type="button" (click)="submit()" *ngIf="submitButton && stuStCreate"
                                                        class="btn size1 btn-primary btn-icon-text floatright  mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 7px;">
                                                            Save
                                                        </span>
                                                    </button>
                                                    <button type="button" (click)="update()" *ngIf="updateButton && stuStUpdate"
                                                    class="btn size1 btn-primary btn-icon-text floatright ml-2 mt-1">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="15vh" src="../../assets/img/save.gif"
                                                            style="margin-right: 7px;">
                                                        Update
                                                    </span>
                                                </button>
                                                 </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 pl-0" *ngIf="tableShow">
                                        <div class="table-responsive" id="table">
                                            <table class="table text-nowrap table-bordered ">
                                                <thead>
                                                    <tr class="text-left">
                                                        <th width="10%" class="f600">
                                                            RgId
                                                        </th>
                                                        <th width="10%" class="f600">
                                                            Name
                                                        </th>
                                                        <th width="10%" class="f600">
                                                            Rg No.
                                                        </th>
                                                        <th width="10%" class="f600">
                                                            Type
                                                        </th>
                                                        <th width="20%" class="f600">
                                                            Year
                                                        </th>
                                                        <th width="20%" class="f600">
                                                            Session
                                                        </th>
                                                        <th width="30%" class="f600">
                                                            Course
                                                        </th>
                                                        <!-- <th width="10%" class="f600">
                                                            Branch
                                                        </th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="curs" *ngFor="let data of tableList"
                                                    (click)="editdata(data)">
                                                        <td>{{data.RgId}}</td>
                                                        <td>{{data.RgName}}</td>
                                                        <td>{{data.RgNo}}</td>
                                                        <td>{{data.Type}}</td>
                                                        <td>{{data.BarToYr}}</td>
                                                        <td>{{data.BarToSn}}</td>
                                                        <td>{{data.CoCode}}</td>
                                                        <!-- <td>{{data.StrId}}</td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>